export const AuthActionType = Object.freeze({
  LOADING_AUTH: "Authorization:: Set application busy",
  SET_AUTH: "Authorization:: Set user logged in status",
  SET_ROLE: "Authorization:: Set user role",
  SET_REGISTRATION: "Registration:: set registration data",
  SET_INVITE_DATA: "Registration:: Set the invite information",
});
